import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, exhaustMap, map, of, switchMap } from 'rxjs';
import {
    loadCashierRevenue, loadCashierRevenueError, loadCashierRevenueSuccess
} from './cashier.actions';
import { CashierService } from 'src/app/shared/services/cashier.service';
import { NotifyService } from 'src/app/shared/services/notify.service';

@Injectable()
export class CashierEffects {
  constructor(
    private service: CashierService,
    private action$: Actions,
    private notify: NotifyService
  ) {}

  loadCashier$ = createEffect(() =>
    this.action$.pipe(
      ofType(loadCashierRevenue),
      exhaustMap(() =>
        this.service
          .getAll()
          .pipe(
            map((res) => loadCashierRevenueSuccess({ list: res })),
            catchError((error) => {
              this.notify.emitError('Falha ao carregar registros')
              return of(error.error['hydra:description'])
          })
          )
      )
    )
  );
}
